export default "__VITE_ASSET__UTLpltuh__"